(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ecomplus/utils"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define([, "axios"], factory);
	else if(typeof exports === 'object')
		exports["ecomClient"] = factory(require("@ecomplus/utils"), require("axios"));
	else
		root["ecomClient"] = factory(root["ecomUtils"], root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__132__) {
return 